import { createReducer, createSelector } from '@reduxjs/toolkit';
import {
  getAllCommentsForHearingSuccess,
  getPaginatedCommentsForHearingSuccess,
} from '../actions/api';
import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { COMMENTDECLINEINFO_INCLUDE } from '../../constants/api';
import { updateDtoList } from '../helpers/reducerHelpers';
import { getEntityId } from '../helpers/apiHelpers';
// -------- Overview --------
// CommentDeclineInfo is included in the following endspoints
// - GET /hering/{hearingId}/comment
// -------- Reducer --------
const commentDeclineInfoReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const commentDeclineInfo = data.filter(
          (include) => include.type === COMMENTDECLINEINFO_INCLUDE,
        );
        return updateDtoList(state, 'all', commentDeclineInfo);
      })
      .addCase(getPaginatedCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const commentDeclineInfo = data.filter(
          (include) => include.type === COMMENTDECLINEINFO_INCLUDE,
        );
        return updateDtoList(state, 'all', commentDeclineInfo);
      });
  },
);
// -------- Selectors --------
const selectGetAllCommentDeclineInfo = (state) =>
  selectAllFromApiState(state, 'commentDeclineInfo');
const allCommentDeclineInfoSelector = createSelector(
  selectGetAllCommentDeclineInfo,
  (commentDeclineInfo) => commentDeclineInfo,
);
const commentDeclineInfoByIdSelector = (commentDeclineInfoId) =>
  createSelector(selectGetAllCommentDeclineInfo, (commentDeclineInfo) =>
    commentDeclineInfo.find(
      (declineInfo) => getEntityId(declineInfo) === commentDeclineInfoId,
    ),
  );
// -------- Exporting --------
export { allCommentDeclineInfoSelector, commentDeclineInfoByIdSelector };
export default commentDeclineInfoReducer;
